import { Header } from '@/components/header'
import { Footer } from '@/components/footer'
import { AssociationsAndSuppliers } from '@/components/AssociationsAndSuppliers';
import { Helmet } from 'react-helmet-async';
import { useEffect, useRef } from 'react';

// Testimonial component
function Testimonial({ 
  content, 
  author 
}: { 
  content: string;
  author: string;
}) {
  return (
    <div className="mb-8 md:mb-12">
      <p className="text-base text-gray-500 mb-3 md:mb-4 leading-relaxed font-text">
        {content}
      </p>
      <p className="font-bold text-gray-800 text-base font-secondary">
        <strong>{author}</strong>
      </p>
    </div>
  )
}

export default function Testimonials() {
  const trustIndexRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = trustIndexRef.current;
    if (!container) return;

    // 1. Prevent duplication: Check if the script is already present
    if (container.querySelector('script[src*="cloudfront.net/bundle.js"]')) return;

    // 2. Clear content before injection to ensure clean render and fix duplication
    container.innerHTML = ''; 

    // 3. Create and append the Trustindex loader directly to the container
    // This fixes the issue of reviews appearing at the bottom of the page
    const sc = document.createElement("script");
    sc.setAttribute("defer", "true");
    sc.setAttribute("src", "https://dbwx2z9xa7qt9.cloudfront.net/bundle.js?cachebust=1779987327371");
    sc.setAttribute("theme", "light");
    sc.setAttribute("footer", "false");
    sc.setAttribute("widget-type", "carousel");
    sc.setAttribute("token", "6a1872483c21ca4d97da0486");
    sc.setAttribute("apiurl", "https://server.onlinereviews.tech/api/v0.0.9");
    sc.setAttribute("stats", "true");
    sc.setAttribute("addReview", "true");
    sc.setAttribute("profile-pic", "true");
    sc.setAttribute("review-name", "true");
    sc.setAttribute("positive-stars", "true");
    sc.setAttribute("wl", "true");
    sc.setAttribute("wlndig", "https://go.basaropt.com/busy-beaver-construction");
    sc.setAttribute("lang", "us");
    sc.setAttribute("brandStyle", "%7B%22sidebar_background%22%3A%22%23ffffff%22%2C%22sidebar_text%22%3A%22%2316187a%22%2C%22brand_button_text_color%22%3A%22white%22%2C%22brand_main_color%22%3A%22%230005a8%22%2C%22brand_button_border_radius%22%3A%2220px%22%2C%22brand_sidebar_text_color_opacity%22%3A%22%2316187a1a%22%2C%22brand_button_hover%22%3A%22rgb(0%2C%206%2C%20193)%22%2C%22brand_button_active%22%3A%22rgb(0%2C%204%2C%20143)%22%2C%22brand_main_color_opacity%22%3A%22%230005a81a%22%2C%22brand_font%22%3A%22Raleway%22%2C%22star_color%22%3A%22%23fff305%22%2C%22brand_main_background%22%3A%22%23ffffff%22%2C%22brand_card_background%22%3A%22white%22%2C%22poweredByLink%22%3A%22https%3A%2F%2Fwww.basaropt.com%22%2C%22poweredicon%22%3A%22https%3A%2F%2Frecensioni-io-static-folder.s3.eu-central-1.amazonaws.com%2Fpublic_onlinereviews%2Freviews.basaropt.com%2Ftopbar.png%22%7D");
    
    container.appendChild(sc);

    return () => {
      // Cleanup: clear container on unmount to prevent ghost widgets
      if (container) container.innerHTML = '';
    }
  }, []);

  const testimonialColumns = [
    [
      {
        content: "We had the deck rebuilt by Busy Beaver. EXCELLENT work – fast, quality work done. Special thanks to Brady and Christina for organizing and proving all the information and to Noel also for his superb craftsmanship in building our deck. Would recommend Busy Beaver if you want EXCELLENT work done with care and attention to detail. Even the clean-up was excellent!",
        author: "Linda from Calgary"
      },
      {
        content: "When it came to choosing a contractor for our project we were happy and relieved that Brady knew what he was doing and was able to help us through the process of getting the most out of out deck. It wasn't long before I knew that Busy Beaver was going to be our choice and wow am I glad we made the right decision. We got he fortress style and it is solid. It costs a little extra but well worth it to go with this style. Kevin is a true master carpenter and so well organized. He methodically put our deck and fence up in about three days. Brady worked with us on the final clean up and we are truly happy with the end result. When I walk around the area I live in, I feel lucky to have such excellent piece of work.",
        author: "Bill & Glenna in Calgary"
      },
      {
        content: "Busy Beaver built our composite deck with clear glass aluminum railing back in August of 2006. The deck has been wonderful and low maintenance. However, this August we noticed our glass pane had slipped. We contacted Busy Beaver to inquire about a repair. Within two weeks Francois was at the house and repaired our railing immediately. 13 years later and under no warranty Busy Beaver stood behind their work!",
        author: "Colleen in Calgary"
      },
      {
        content: "We added to an existing deck and they incorporated the 2 areas seamlessly and beautifully. We interviewed a few contractors and chose Busy Beaver for a few reasons – Francois had great design ideas, gave us a detailed breakdown of the work and cost and responded quickly. We had an aggressive timeline due to our son's upcoming wedding and he came through as promised and even earlier than we expected. We are so grateful for that. His crew is extremely professional, hard working, clean and quick. We also appreciated Christina keeping us informed and following up with us throughout the project. We know this is quality work and we will enjoy our new deck for years to come. We would highly recommend them.",
        author: "Carmen and Harley in Calgary"
      },
      {
        content: "What a pleasure finding this company! We had a new deck put in and an old one removed. Francois, Christina and the entire work crew were so attentive and professional and fun. I can't say enough about the job. The deck is stunning and it was done on budget and they even pushed to have it done early for a party we were throwing. Hire this company. You will not be disappointed ever! That is a huge peace of mind these days. Loved them",
        author: "Donna Petruic"
      }
    ],
    [
      {
        content: "Francois, Christina and crew were very responsive and provided ideas for the look of my deck. Very pleasant and professional to work with. I am extremely pleased with the finished deck. Would highly recommend.",
        author: "Cindy Coe"
      },
      {
        content: "I hired Busy Beaver to: demolish & haul away a 30 year old deck/gazebo & build a new composite deck & aluminum railing. The reason I hired Busy Beaver was because of their high rating on HomeStars, a recommendation from a neighbour & the demeanour & professionalism of the company owner Francois. I interacted with many of their team members: Christina, Noel & Brady and every one of them was exceptional. The demolition and construction of the new deck was completed in just 1 week with the railing installed a week later. The contract was fixed price with no additional costs. I cannot say enough about this company. Cristina & Francois, thanks for a great job; you can always use me as a reference.",
        author: "JimB in Calgary"
      },
      {
        content: "We picked Busy Beaver to complete our new deck because from the very start Francois was concerned about doing it right vs cutting corners. We appreciated his feedback and ideas for completing our deck. Noel, who worked on our deck, was friendly, professional and did an excellent job. Started and finished when they said they would. Thank you again, would definitely recommend your company to others.",
        author: "Danielle in Calgary"
      },
      {
        content: "The whole experience was professional, easy, and quality. We found a contractor who did what he said, on time and on budget. 🙂 We had already torn out our old deck. Francois came to assess, gave great suggestions, had plans and a quote to us within days. We did have to wait about 2 months for the build to start (we were told this right from the start), but once the work began, it was incredibly quick and painless. All inquiries were answered promptly, the worksite was cleaned up, the craftsmen were friendly and professional. Would happily recommend Francois and his team to anyone looking for a new deck.",
        author: "Faun in Calgary"
      }
    ],
    [
      {
        content: "We could not be happier with our decision to have had Busy Beaver build our new Deck. Francois and his team are very accommodating and are experienced professionals. There is no corner cutting here. They insist on quality from their suppliers and deliver a product that is well above average. We do not hesitate to recommend Busy Beaver to anyone looking to do outdoor improvements.",
        author: "Dave and Diana in Calgary"
      },
      {
        content: "Busy Beaver did a wonderful job removing our old, water-damaged, second-story deck and building us a wonderful, new deck with the same basic footprint. It was no problem to get custom-height railings and choose the colours we wanted for everything. They took our special requests into consideration and didn't consider the project finished until all our requirements were met. Highly recommended.",
        author: "Shana Drinnan in Calgary"
      },
      {
        content: "We are absolutely thrilled with the job Francois and his folks did for us. The job was handled most professionally from start to finish and exceeded our expectations thanks to Francois' knowledgeable advice. The project was completed on schedule and according to budget. They also left the worksite in better condition than it was when the job started. I highly recommend Busy Beaver for your deck and fencing projects.",
        author: "Glen in Calgary"
      },
      {
        content: "Exceptional is the word I would use to describe Busy Beaver Construction! From the moment we met with Francois, we were very impressed with his commitment to excellence and customer satisfaction. Francois and his entire crew were professional, personable, and demonstrated that they truly care about their customers and the projects that they undertake. We were extremely pleased at every stage of this project and are thrilled with the final appearance of our deck. I could not recommend this company more highly to anyone who is looking to have a deck constructed. I would not hesitate to contact Francois again should we have another project to complete. Well Don Busy Beaver Construction!!!",
        author: "Karen from Calgary"
      },
      {
        content: "François and Christine were both a real pleasure to work with from quote to completing the project. We absolutely love our deck. Each phase of the project was executed with professionalism and everyone was super friendly. They used quality materials and our deck is a solid structure. It looks real modern and we are proud to show it off. Busy Beaver is the best.",
        author: "Joe Shenfield"
      }
    ]
  ];

  // Added Schema Data for the Testimonials Page
  const schemaData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "@id": "https://busybeaverconstruction.com/testimonials",
        "url": "https://busybeaverconstruction.com/testimonials",
        "name": "Customer Testimonials | Busy Beaver Construction",
        "description": "Read real customer testimonials of Busy Beaver Construction, Calgary's premier deck and fence builder.",
        "publisher": {
          "@type": "Organization",
          "@id": "https://busybeaverconstruction.com/#organization",
          "name": "Busy Beaver Construction"
        }
      },
      {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://busybeaverconstruction.com/"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Testimonials",
            "item": "https://busybeaverconstruction.com/testimonials"
          }
        ]
      }
    ]
  };

  return (
    <main>
      <Helmet>
        <title>Customer Testimonials | Busy Beaver Construction | Calgary Deck & Fence Builder</title>
        <meta name="description" content="Read real customer testimonials of Busy Beaver Construction, Calgary's premier deck and fence builder." />
        <link rel="canonical" href="https://busybeaverconstruction.com/testimonials" />
      </Helmet>
      
      {/* JSON-LD Schema placed OUTSIDE Helmet to ensure rendering */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }} />

      <Header />

      {/* Hero Banner */}
      <section className="relative h-[400px] flex items-center justify-center">
        <img 
          src="/assets/images/Decks/Composite Decks/DECK_PRO-Legacy-Tigerwood-and-Mocha-5.jpg"
          alt="Busy Beaver Construction custom deck in Calgary"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="relative z-10 mt-64 text-center">
          <div className="inline-block bg-busy-green rounded py-3 mx-4 px-4 lg:px-8">
            <p className="text-white text-base font-medium">Calgary's Leading Custom Deck & Fence Builder</p>
          </div>
        </div>
      </section>

      {/* Review Widget Section (Trustindex) */}
      <section className="py-12 md:py-16 bg-white border-b">
        <div className="container">
          <h2 className="text-5xl md:text-6xl mb-10 text-center font-primary text-text-dark">
            Customer Reviews
          </h2>
          <div className="flex justify-center">
            {/* Trustindex reviews will be injected directly into this ref container */}
            <div id="wid_1779987327371" ref={trustIndexRef} className="w-full max-w-5xl mx-auto min-h-[300px]">
               {/* Widget content loads here */}
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Grid Section */}
      <section className="py-12 md:py-16 bg-white">
        <div className="container max-w-6xl">
          <h1 className="text-center text-5xl lg:text-6xl font-primary mb-8 md:mb-14">Testimonials</h1>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10">
            {testimonialColumns.map((column, colIndex) => (
              <div key={colIndex} className="px-4 md:px-2">
                {column.map((testimonial, index) => (
                  <Testimonial 
                    key={index}
                    content={testimonial.content}
                    author={testimonial.author}
                  />
                ))}
              </div>
            ))}
          </div>

          {/* Review Platform Links */}
          <div className="mt-16 text-center">
            <h2 className="text-3xl lg:mb-0 mb-12">See more than 50 reviews on Google and Homestars</h2>
            <div className="flex flex-wrap justify-center items-center gap-10 mt-8">
              <a href="https://www.google.com/search?q=busy+beaver+construction" target="_blank" rel="noopener noreferrer">
                <img 
                  src="/assets/images/2021/02/SeekPng.com_yelp-icon-png_1334332.png"
                  alt="Google Reviews"
                  className="h-16 w-auto"
                />
              </a>
              <a href="https://www.homestars.com/profile/2599454-busy-beaver-construction" target="_blank" rel="noopener noreferrer">
                <img 
                  src="/assets/images/2021/02/homestars.png"
                  alt="HomeStars Reviews"
                  className="h-16 w-auto"
                />
              </a>
            </div>
          </div>
        </div>
      </section>

      <AssociationsAndSuppliers />
      <Footer />
    </main>
  )
}